<template lang="pug">
  .col-24.flexD.alignItemsCenter.justifyCenter.flexDirectionColumn.l-padding-top-6em.m-padding-top-2em
    .col-24.flexD.alignItemsCenter.justifyCenter.l-margin-bottom-4em.m-margin-bottom-2em
      .col-6.flexD.m-hidden(style="justify-content: left")
        .col-21.msFlexNegative
          img.block.col-24(:src="img.left")
      .col-9.flexD.flexDirectionColumn.minWidth400.m-minWidthAuto.m-width-90
        .col-24.flexD.justifyCenter.l-margin-bottom-4em
          .col-18
            img.col-24.block(:src="img.logo")
        .col-24.l-margin-bottom-2em
          .font-section.textAlignLeft(v-for="(item, index) in text.section" :key="index") {{ item.content }}
        .col-24.flexD.justifyCenter
          a.font-section.color-font-deepRed.fontBold.cursorPointer.textDecorationNone(:href="url" target="_blank")
            | {{ text.more }}
            i.fa.fa-arrow-circle-o-right.l-margin-left-10
      .col-6.flexD.m-hidden(style="justify-content: right")
        .col-21.msFlexNegative
          img.block.col-24(:src="img.right")
    .col-24.flexD.alignItemsCenter.justifyCenter.l-margin-bottom-4em
      .col-12.minWidth700.m-minWidthAuto.m-width-100.msFlexNegative
        video.block.col-24(:src="video.stigler" controls="controls" :poster="img.poster")
    .col-24.flexD.alignItemsCenter.justifyCenter
      .col-2.bg-wine.cursorPointer(v-for="(item, index) in items" :key="index" :style="{backgroundImage:'url('+ item.img +')'}" @click="openPopup(index)")

    PopupStigler(ref="popupStigler" :content="popupValue")
</template>

<script>
  import PopupStigler from '../popup/popupStigler.vue'

  export default {
    name: 'stigler',
    props: ['content'],
    components: {
      PopupStigler
    },
    data(){
      return{
        text: {
          section: [
            { content: this.$t('stigler.content_1') },
            { content: this.$t('stigler.content_2') },
          ],
          more: this.$t('stigler.more')
        },
        img: {
          left: require('@/assets/img/stigler_left.png'),
          right: require('@/assets/img/stigler_right.png'),
          logo: require('@/assets/img/logo/logo_stigler.png'),
          poster: require('@/assets/img/cover_stigler.jpg'),
        },
        video: {
          stigler: require('@/assets/media/stigler.mp4')
        },
        url: 'https://shop375179300.taobao.com/',
        items: [
          { img: require('@/assets/img/stigler/704.png') },
          { img: require('@/assets/img/stigler/204.png') },
          { img: require('@/assets/img/stigler/711.png') },
          { img: require('@/assets/img/stigler/804.png') },
          { img: require('@/assets/img/stigler/807.png') },
          { img: require('@/assets/img/stigler/805.png') },
          { img: require('@/assets/img/stigler/310.png') },
          { img: require('@/assets/img/stigler/709.png') },
          { img: require('@/assets/img/stigler/508.png') },
          { img: require('@/assets/img/stigler/408.png') },
          { img: require('@/assets/img/stigler/308.png') },
        ],
        popupValue: {
          popup: false,
          index: 0
        }
      }
    },
    computed: {},
    methods:{
      openPopup(index){
        this.popupValue = {
          popup: true,
          index: index
        }
      },
    },
    created(){}
  }
</script>
